<template>
  <el-card>
    <ht-action-panel :on-search="mySearch" :on-clear="myClear">
      <template slot="left">
        <el-input v-model="listQuery.projectName" placeholder="记录名称" />
        <common-search ref="commonSearch" :staff-placeholder="'记录人'" @handleSelect="handleSelect" @selectDate="selectDate" />
      </template>
      <!--      <template slot="right">-->
      <!--        <ht-button v-if="!showSelector" type="danger" icon="el-icon-delete" @click="showSelectedCheckRecord">-->
      <!--          批量删除-->
      <!--        </ht-button>-->
      <!--        <template v-else>-->
      <!--          <ht-button type="danger" icon="el-icon-delete">-->
      <!--            确定删除-->
      <!--          </ht-button>-->
      <!--          <ht-button type="text" @click="showSelector = false">取消删除</ht-button>-->
      <!--        </template>-->
      <!--      </template>-->
    </ht-action-panel>
    <ht-table
      ref="list"
      v-loading="isLoading"
      :data="list"
      :row-key="getRowKey"
      :default-sort="{prop: 'createdAt', order: 'descending'}"
      style="cursor: pointer"
      @row-click="handleRowClick"
      @selection-change="selectionChange"
      @sort-change="sortChange"
    >
      <!--      <el-table-column-selection v-if="showSelector" />-->
      <el-table-column label="序号" type="index" fixed="left" />
      <ht-table-column v-for="i in labelToProps" :key="i.prop" :label="i.label" :prop="i.prop" :sortable="i.sortable">
        <template v-slot="{row}">
          <span v-if="i.secondProp">{{ (row[i.firstProp] && row[i.firstProp][i.secondProp]) ? row[i.firstProp][i.secondProp] : '-' }}</span>
          <span v-else>{{ row[i.prop] }}</span>
        </template>
      </ht-table-column>
      <ht-table-column-operation :width="130">
        <template v-slot="{row}">
          <ht-button type="text" icon="el-icon-view" @click="gotoView(row.id)">详情</ht-button>
          <ht-popover-button
            icon="el-icon-delete"
            type="text"
            :danger-text="true"
            confirm-title="请确认是否要删除该条数据？"
            @confirmed="deleteItem(row)"
          >删除
          </ht-popover-button>
        </template>
      </ht-table-column-operation>
    </ht-table>
    <ht-pagination
      style="float: right;margin-bottom: 10px"
      :total="page.total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.perPage"
      @pagination="getList"
    />
  </el-card>
</template>

<script>
import HtListContainer from '@/components/HtListContainer/index'
import { getProjectCheckApi, deleteProjectCheckDetail } from '@/api/projectCheck/projectReports'
import { sortQuery } from '@/utils'

export default {
  extends: HtListContainer,
  props: {
    bizType: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      labelToProps: [
        {
          label: '编号',
          prop: 'recordNo'
        },
        {
          label: '记录名称',
          prop: 'projectName',
          sortable: 'custom'
        },
        {
          label: '记录人',
          prop: 'staff.fullName',
          firstProp: 'staff',
          secondProp: 'fullName',
          sortable: 'custom'
        },
        {
          label: '时间',
          prop: 'createdAt',
          sortable: 'custom'
        },
        {
          label: '位置区域',
          prop: 'locationAndInfo',
          sortable: 'custom'
        },
        {
          label: '备注',
          prop: 'comment'
        },
        {
          label: '条数',
          prop: 'checkItemCount',
          sortable: 'custom'
        }
      ],
      showSelector: false
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.beforeGetList()
      getProjectCheckApi(this.listQuery).then((resp) => {
        this.afterGetList(resp)
      })
    },
    selectionChange(val) {
      this.selectedCheckRecord = val
    },
    showSelectedCheckRecord() {
      this.showSelector = true
      this.$message({
        message: '请勾选需要批量删除的记录',
        center: true,
        type: 'warning'
      })
    },
    deleteItem(row) {
      deleteProjectCheckDetail(row.id).then(() => {
        this.$message({ message: '删除成功！', center: true, type: 'success' })
        this.getList()
      })
    },
    handleSelect(id) {
      this.listQuery.staffId = id
    },
    selectDate(date) {
      if (date) {
        this.listQuery.startAt = date[0]
        this.listQuery.endAt = date[1]
      }
    },
    mySearch() {
      const searchForm = this.$refs.commonSearch.searchForm
      if (searchForm.searchStaffName) {
        if (this.listQuery.staffId) {
          this.onSearch()
        } else {
          this.$message({ message: '请在下拉框内选择员工后进行搜索', center: true, type: 'warning' })
        }
      } else if (this.listQuery.startAt && this.listQuery.endAt) {
        this.onSearch()
      } else {
        this.onSearch()
      }
    },
    myClear() {
      this.$refs.commonSearch.searchForm = { searchStaffName: undefined, searchDate: undefined }
      this.onClear()
    },
    handleRowClick(row, column) {
      if (column.label !== '操作' && !this.showSelector) {
        this.gotoView(row.id)
      }
    },
    gotoView(recordId) {
      this.$router.push({ name: 'projectSiteRecordReportView', params: { recordId: recordId }})
    },
    sortChange(ev) {
      this.listQuery.sort = sortQuery(ev)
      this.getList()
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-table__body tr.hover-row>td{
  background-color: #eaecfc !important;
}
</style>
